import xml from "csi/xml";

export const SIZE_VARIATION_BOM_SIZES = "PMSBOMSizes";

export const SIZE_PARAMS = {
	aggregation: SIZE_VARIATION_BOM_SIZES,
	attrType: xml.ATTR_REF,
	attr: "PMSSize",
	common: "CommonSize",
	composition: "PartMaterialSizes",
	nodeType: "PartMaterialSize",
	operation: "PartMaterialSetSizes",
};

export const QTY_PARAMS = {
	aggregation: SIZE_VARIATION_BOM_SIZES,
	attrType: xml.ATTR_DOUBLE,
	attr: "Quantity",
	common: "QtyDefault",
	composition: "PartMaterialQuantities",
	nodeType: "PartMaterialQuantity",
	operation: "PartMaterialSetQuantities",
};

export const SIZE_SPEC_PARAMS = {
	aggregation: SIZE_VARIATION_BOM_SIZES,
	attrType: xml.ATTR_REF,
	attr: "PMSSizeSpec",
	common: "CommonSizeSpec",
	composition: "PartMaterialSizeSpecs",
	nodeType: "PartMaterialSizeSpec",
	operation: "PartMaterialSetSizeSpecs",
};

export const SIZE_VARIATION_MAP = {
	Quantity: QTY_PARAMS,
	PMSSize: SIZE_PARAMS,
	PMSSizeSpec: SIZE_SPEC_PARAMS,
};
